import SalesReport from './Report'
import Config from './Config'

export const paths = [
    {
        path: "/sales/report",
        component: SalesReport
    },
    {
        path: "/settings/sales",
        component: Config
    }
]

export const SalesRouters = {
    icon: "chart-line",
    path: "/building-page...",
    label: "Relatórios",
    tree: [
        {
            icon: "chart-line",
            path: "/sales/report",
            label: "Relatório de vendas"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Sales/routers.js